export const iconFontAwesomeCharityPiggyBank = (
	<i className="fa-solid fa-piggy-bank"></i>
);
